// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"febef29d","732":"ea66b3df","977":"d8734466"}[chunkId] + ".chunk.js";
};